import { Injectable } from '@angular/core';
import { Inventory } from '@buyiq-app/inventory/models/inventory';
import { LocalForageService } from '@buyiq-core/storage/local-forage.service';
import { ItemKey, OfflineStorage, StoreName } from '@buyiq-core/storage/storage';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class InventoryStorageService implements OfflineStorage<Inventory> {
    constructor(
        private localForageService: LocalForageService
    ) {
    }

    clearStorage(): Observable<void> {
        return this.localForageService.clearStorage(StoreName.Inventory);
    }

    getItem(key: string): Observable<Inventory> {
        return this.localForageService.getItem(key, StoreName.Inventory);
    }

    removeItem(key: string): Observable<void> {
        return this.localForageService.removeItem(key, StoreName.Inventory);
    }

    setItem(key: string, value: Inventory): Observable<Inventory> {
        return this.localForageService.setItem(key, value, StoreName.Inventory);
    }

    getAll(): Observable<Array<Inventory>> {
        return this.localForageService.getAll(StoreName.Inventory);
    }

    setItems(items: Array<Inventory>): Observable<Array<Inventory>> {
        return this.localForageService.setItems(items, ItemKey.Upc, StoreName.Inventory);
    }
}
